import React from "react";
import { motion } from "framer-motion";
import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import AIChatbot from "../components/AIChatbot";
import "./AIPage.css";

const AIPage = () => {
  return (
    <div className="aip-portal">
      <Navigation />

      {/* Sovereign HUD Visual Overlays */}
      <div className="aip-grid-field"></div>
      <div className="aip-scanline-overlay"></div>
      <div className="aip-kinetic-glow"></div>

      <main className="aip-main">
        <motion.header
          className="aip-hero"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <div className="aip-hud-badge">
            <span className="aip-pulse-dot"></span>
            <span>Medico AI V1.5</span>
          </div>

          <h1 className="aip-title">
            How can <span className="aip-highlight">I help you?</span>
          </h1>

          <p className="aip-subtitle">
            Synchronize with the Medico.in neural core for real-time guidance on sensor
            configuration, clinical data flows, and platform security.
          </p>
        </motion.header>

        <motion.div
          className="aip-interface-anchor"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
        >
          <AIChatbot isStandalone={true} />
        </motion.div>
      </main>

      <FooterSection />
    </div>
  );
};

export default AIPage;
